// Import app settings generated by the setup script
let appSettings
try {
  appSettings = require("./appSettings.json")
} catch {
  // Fallback if appSettings.json doesn't exist
  appSettings = { appEnv: "development" }
}

const getApiUrl = () => {
  const environment = appSettings.appEnv

  switch (environment) {
    case "production":
      return "https://api.taskfortress.com"
    case "development":
    default:
      return "http://localhost:3000"
  }
}

const getExtraConfig = () => {
  const environment = appSettings.appEnv

  // Base configuration shared across environments
  const config = {
    apiUrl: getApiUrl(),
    analyticsEnabled: environment !== "development",
    matomoUrl: "https://matomo.hiddentao.com/",
  }

  // Environment-specific overrides
  switch (environment) {
    case "production":
      return {
        ...config,
        matomoSiteId: "3",
      }
    case "development":
    default:
      return {
        ...config,
        matomoSiteId: "1",
      }
  }
}

// Import base configuration from app.json
const appJson = require("./app.json")

// Export enhanced configuration with environment-specific values
module.exports = {
  ...appJson.expo,
  // Add releaseChannel based on APP_ENV
  releaseChannel: appSettings.appEnv,
  // Add extra config for environment variables
  extra: getExtraConfig(),
}
